import React, { useEffect, useState } from "react";
import "./index.scss";
import MediaPlayer, { mediaTypes } from "@/components/media-player/mediaplayer";
import { PageIcon, PageIconType } from "@/types";
import ShowTextNote from "./ShowTextNote";
import ShowUserDrawing from "./ShowUserDrawing";
import { PageCanvasService } from "@/database/smartBookModelService";

interface ActivityPopupProps {
  activity: PageIcon;
  deleteNote?: (noteId: string) => void;
}

const ActivityPopup: React.FC<ActivityPopupProps> = ({
  activity,
  deleteNote,
}) => {
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [activityPath, setActivityPath] = useState<string>("");

  const renderSwitch = (activity: PageIcon, path: string) => {
    switch (activity.type) {
      case PageIconType.Sound:
        return (
          <MediaPlayer
            url={path}
            type={mediaTypes.audio}
            transcript={activity.transcript}
            title={undefined}
            footer={undefined}
          />
        );
      case PageIconType.Video:
        return (
          <MediaPlayer
            url={path}
            type={mediaTypes.video}
            transcript={activity.transcript}
            title={undefined}
            footer={undefined}
          />
        );
      case PageIconType.Image:
        return (
          <div style={{ textAlign: "center" }}>
            <img style={{ maxWidth: "900px" }} src={path}></img>
          </div>
        );
      case PageIconType.Html:
        return (
          <div dangerouslySetInnerHTML={{ __html: activity.content || "" }} />
        );
      case PageIconType.TextNote:
        return (
          <ShowTextNote userNote={activity} isUpdate={isUpdate}></ShowTextNote>
        );
      case PageIconType.Drawing:
        return <ShowUserDrawing userNote={activity}></ShowUserDrawing>;
      default:
        return null;
    }
  };

  const getActivityPath = async () => {
    const filePath = await PageCanvasService.getActivityPath(
      activity.bookId || 0,
      activity.entityId,
      activity
    );
    setActivityPath(filePath);
  };
  useEffect(() => {
    getActivityPath();
  }, [activity]);

  return (
    <div>
      {activity && activityPath && renderSwitch(activity, activityPath)}
      {activity.isUserContent === true && deleteNote && (
        <div className="margin-top-10 buttons flex justify-content-center">
          {activity.type === PageIconType.TextNote && (
            <button
              className="obro-btn obro-secondary-btn margin-top-10"
              onClick={() => setIsUpdate(true)}
            >
              Düzenle
            </button>
          )}
          <button
            className="obro-btn obro-danger-btn margin-top-10"
            onClick={() => deleteNote(activity.id)}
          >
            Sil
          </button>
        </div>
      )}
    </div>
  );
};
export default ActivityPopup;
